module.exports = __webpack_public_path__ + "assets/Image-Carousel-Prev.svg?ver=fb159fd4";